import Version from './version';

export default (ua) => {
  let matched;
  const browser = {
    name: 'unknown',
    version: new Version('0.0.0'),
  };

  matched = ua.match(/(?:UCWEB|UCBrowser\/)([\d.]+)/);
  if (matched) {
    browser.name = 'UC';
    browser.isUC = true;
    browser.version = new Version(matched[1]);
    return browser;
  }

  matched = ua.match(/MQQBrowser\/([\d.]+)/);
  if (matched) {
    browser.name = 'QQ';
    browser.isQQ = true;
    browser.version = new Version(matched[1]);
    return browser;
  }

  matched = ua.match(/(?:Firefox|FxiOS)\/([\d.]+)/);
  if (matched) {
    browser.name = 'Firefox';
    browser.isFirefox = true;
    browser.version = new Version(matched[1]);
    return browser;
  }

  matched = ua.match(/Edge\/([\d.]+)/);
  if (matched) {
    browser.name = 'Edge';
    browser.isEdge = true;
    browser.version = new Version(matched[1]);
    return browser;
  }

  matched = ua.match(/MSIE\s([\d.]+)/) || ua.match(/IEMobile\/([\d.]+)/);
  if (matched) {
    browser.version = new Version(matched[1]);

    /* istanbul ignore else */
    if (ua.match(/IEMobile/)) {
      browser.name = 'IEMobile';
      browser.isIEMobile = true;
    } else {
      browser.name = 'IE';
      browser.isIE = true;
    }

    return browser;
  }

  matched = ua.match(/(?:Chrome|CriOS)\/([\d.]+)/);
  if (matched) {
    browser.name = 'Chrome';
    browser.isChrome = true;
    browser.version = new Version(matched[1]);

    if (ua.match(/Version\/[\d+.]+\s*Chrome/)) {
      browser.isWebview = true;
    }

    return browser;
  }

  if (ua.match(/Safari/)) {
    matched = ua.match(/Android[\s/]([\d.]+)/);
    if (matched) {
      browser.name = 'Android';
      browser.isAndroid = true;
      browser.version = new Version(matched[1]);

      return browser;
    }

    matched = ua.match(/Version\/([\d.]+)/);
    if (matched) {
      browser.name = 'Safari';
      browser.isSafari = true;
      browser.version = new Version(matched[1]);
      return browser;
    }
  }


  matched = ua.match(/OS ([\d_.]+) like Mac OS X/);
  if (ua.match(/iPhone|iPod|iPad/) && matched) {
    browser.name = 'Safari';
    browser.isWebview = true;
    browser.isSafari = true;
    browser.version = new Version(matched[1].replace(/_/g, '.'));

    if (ua.match(/WK$/)) {
      browser.isWKWebview = true;
    }

    return browser;
  }

  return browser;
};
